<template>
  <div id="home">
    <div class="header">
      <div
        style="display: flex; justify-content: flex-start; align-items: center"
      >
        <img class="profile" src="../assets/profile.png" alt="profile" />
        <div class="user-info">
          <button class="logout-btn" @click="handleLogout">Logout</button>
        </div>
      </div>
      <img class="store-logo" src="../assets/logo_new.png" alt="store logo" />
      <div>
        <button @click="onGetPricePointsClicked">Get price points</button>
        <br />
        <div
          style="
            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <input
            type="text"
            v-model="locale"
            placeholder="locale"
            style="
              padding: 10px;
              border: 1px solid #ccc;
              border-radius: 20px;
              font-size: 16px;
            "
          />
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="bundle-container">
        <img
          data-testid="offer-1"
          class="bundle"
          src="../assets/bundle.png"
          alt="bundle"
          @click="createOrder"
        />
        <div class="price">{{ price }}</div>
      </div>
      <div class="bundle-container">
        <img
          data-testid="offer-2"
          class="bundle"
          src="../assets/bundle.png"
          alt="bundle"
          @click="createOrder"
        />
        <div class="price">{{ price }}</div>
      </div>
      <div class="bundle-container">
        <img
          data-testid="offer-3"
          class="bundle"
          src="../assets/bundle.png"
          alt="bundle"
          @click="createOrder"
        />
        <div class="price">{{ price }}</div>
      </div>
    </div>
    <h2 v-if="isFetchingOrder">fetching</h2>
    <div>
      <AppchargeCheckout
        v-if="loadBundle"
        :checkoutUrl="checkoutUrl"
        :locale="locale"
        :on-initial-load="handleInitialLoad"
        :on-close="closeCheckout"
        :on-payment-intent="handlePaymentIntent"
      />
    </div>
    <JsonEditorVue
      v-model="mockData"
      mode="json"
      :navigationBar="false"
      :mainMenuBar="false"
      :style="{
        maxHeight: '50vh',
        textAlign: 'left',
      }"
    />
  </div>
</template>

<script>
import {
  getPricePoints,
  AppchargeCheckout,
  AppchargeCheckoutInit,
} from "appcharge-checkout-vuejs-sdk";
import axios from "axios";
import JsonEditorVue from "json-editor-vue";

const mockData = {
  customer: {
    id: "John Doe",
    email: "test@appcharge.com",
  },
  priceDetails: {
    price: 1550,
    currency: "usd",
  },
  offer: {
    name: "Crazy Pack",
    sku: "CrazyPack",
    assetUrl:
      "https://media-dev.appcharge.com/media/64ad4f25cc1a482bac467ae5/fire-fire-logo-fire-fire-icon-fire-sign-fire-symbol-transparent-background-ai-generative-free-png.png",
    description: "Crazy Pack Bundle",
  },
  items: [
    {
      name: "Coins",
      assetUrl: "https://media-dev.appcharge.com/media/product-3.png",
      sku: "coins_xoxoxo",
      quantity: 6580,
    },
    {
      name: "Tokens",
      assetUrl: "https://media-dev.appcharge.com/media/bills.png",
      sku: "coins_xoxoxo",
      quantity: 150,
    },
    {
      name: "Boosters",
      assetUrl: "https://media-dev.appcharge.com/media/booster.png",
      sku: "coins_xoxoxo",
      quantity: 3,
    },
  ],
  sessionMetadata: {},
};
const env = process.env.VUE_APP_ENV || "staging";
const lambdaPrefix = process.env.VUE_APP_LAMBDA_PREFIX || "rryhv338ih";
const publisherToken =
  process.env.VUE_APP_PUBLISHER_TOKEN ||
  "46b6c3990ad3fbbc0457922903dd6b2f0d34ad7058bbb46615ee268c82dae618";
const checkoutToken =
  process.env.VUE_APP_CHECKOUT_TOKEN ||
  "7d599f16350cf66feb3218c5e5ca107452b947ec39c0c3fc43d0aa471986d0fc";

const createSessionUrl =
  env === "staging"
    ? "https://n8iiv57d99.execute-api.us-east-1.amazonaws.com/ac-stg/createSession"
    : `https://${lambdaPrefix}.execute-api.us-east-1.amazonaws.com/${env}/createSession`;

export default {
  name: "Home",
  data: () => {
    return {
      isFetchingOrder: false,
      loadBundle: false,
      sessionToken: "",
      checkoutUrl: "",
      mockData,
      price: `$${(mockData.priceDetails.price / 100).toFixed(2)}`,
      environment: env === "production" ? "prod" : env,
      publisherToken,
      checkoutToken,
      locale: "",
      userEmail: localStorage.getItem("__ac_user") || "User",
    };
  },
  components: {
    JsonEditorVue,
    AppchargeCheckout,
    AppchargeCheckoutInit,
  },
  methods: {
    handleInitialLoad() {
      this.isAppchargeCheckoutLoaded = true;
    },
    createOrder() {
      this.isFetchingOrder = true;
      axios
        .post(
          createSessionUrl,
          this.mockData,
          {
            headers: {
              "x-publisher-token": publisherToken,
            },
          }
        )
        .then((response) => {
          this.sessionToken = response.data.checkoutSessionToken;
          this.checkoutUrl = response.data.parsedUrl;
          this.loadBundle = true;
          this.isFetchingOrder = false;
        });
    },
    closeCheckout() {
      this.loadBundle = false;
    },
    async onGetPricePointsClicked() {
      try {
        const pricePoints = await getPricePoints(env);
        const relevantPrice = pricePoints.pricingPoints.find(
          (p) => p.basePriceInUSD == this.mockData.priceDetails.price,
        ).formattedPrice;
        this.price = relevantPrice;
      } catch (error) {
        console.error(error);
      }
    },
    handleLogout() {
      localStorage.removeItem("__ac_user");
      localStorage.removeItem("__ac_token");
      localStorage.removeItem("__ac_role");
      this.$router.push("/login");
    },
    handlePaymentIntent(params) {
      console.log("onPaymentIntent", {params});
    },
  },
  watch: {
    mockData: function (val) {
      this.price = `$${(val.priceDetails.price / 100).toFixed(2)}`;
      this.mockData = val;
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

#home {
  position: absolute;
  height: 100%;
  width: 100%;
  background: url("../assets/bg_1.jpg");
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #2c3e50;
  padding-top: 60px;
}

.store-logo {
  max-width: 50%;
}

.profile {
  height: 60px;
  margin-right: 10px;
}

.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.user-email {
  color: white;
  font-size: 12px;
  margin-bottom: 5px;
  text-shadow: 0px 0px 3px #000;
}

.logout-btn {
  background-color: #ff4757;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.logout-btn:hover {
  background-color: #ff3742;
}

.header {
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header > div {
  width: 100px;
}

.price {
  height: 40px;
  width: 80px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  color: white;
  font-size: 18px;
  font-weight: 600;
  text-shadow: 0px 0px 6px #000;
}

.wrapper {
  margin-bottom: 60px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
}

.bundle-container {
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.bundle-container:hover {
  transform: scale(1.05);
}

.bundle {
  max-width: 350px;
  height: auto;
}

button {
  background-color: #4a0350;
  color: white;
  border: 1px solid #edce74;
  border-radius: 4px;
  font-weight: 600;
  padding: 8px 12px;
  cursor: pointer;
}

button:hover {
  background-color: #5a1360;
}
</style>
